// extracted by mini-css-extract-plugin
export default {"widgets":"InfoWidget_widgets__2XLo7"};